import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AgrimotorService } from '../agrimotor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from '../../quote.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ag-quote-view',
  templateUrl: './ag-quote-view.component.html',
  styleUrls: ['./ag-quote-view.component.css', '../../quote.component.css']
})
export class AgQuoteViewComponent implements OnInit {
  staticData;
  id = this.route.snapshot.params.quote_id;
  selectedIndex = 0;
  isAdmin = false;
  isStaff = false;
  isBroker = false;

  constructor(private as: AgrimotorService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal,
    private quoteService: QuoteService, private sessionSt: LocalStorageService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) { this.isAdmin = true; }
    if (this.sessionSt.retrieve('is_staff')) { this.isStaff = true; }
    if (this.sessionSt.retrieve('is_broker')) { this.isBroker = true; }
    this.getAccessToken();
    this.getQuote();
    if (this.sessionSt.retrieve('is_broker')) { this.selectedIndex = 5; }
  }

  authDetails: string = '';
  getAccessToken() {
    let data = {
      'client_id': environment.AGRIMOTOR_CLIENT_ID,
      'client_secret': environment.AGRIMOTOR_CLIENT_SECRET,
      'grant_type': environment.AGRIMOTOR_GRANT_TYPE,
      'scope': environment.AGRIMOTOR_SCOPE,
    };
    this.as.getAccessToken(data)
      .subscribe(
        (response: any) => {
          if (response.access_token) {
            this.authDetails = response;
            this.getStaticData(response);
          }
        },
        (error) => { }
      );
  }

  getStaticData(authDetails) {
    this.as.getStaticData(authDetails)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        },
        (error) => { }
      );
  }

  quoteDetails;
  fullQuote;
  getQuote(authDetails = '') {
    this.as.getAgrimotorData(this.route.snapshot.params.quote_id)
      .subscribe(
        (response: any) => {
          this.quoteDetails = response.result.quote_data.quote_versions[0].agriculture_data.data.attributes;
          this.quoteDetails.insurance_status_id = response.result.quote_data.insurance_status_id;
          this.quoteDetails.id = response.result.quote_data.quote_versions[0].id;
          this.quoteDetails.company_id = response.result.quote_data.quote_versions[0].company_id;
          this.quoteDetails.company_name = response.result.quote_data.quote_versions[0].company_name;
          this.quoteDetails.is_send_email = response.result.quote_data.quote_versions[0].is_send_email;
          this.quoteDetails.type = response.result.quote_data.quote_versions[0].type;
          this.quoteDetails.broker_id = response.result.quote_data.quote_versions[0].broker_id;
          this.quoteDetails.notes = response.result.quote_data.quote_versions[0].notes;
          if (response.result.quote_data.quote_versions[0].financial_details) {
            this.quoteDetails.peliwica_fee = response.result.quote_data.quote_versions[0].financial_details.fees;
            this.quoteDetails.broker_commission = response.result.quote_data.quote_versions[0].financial_details.broker_commission;
            this.quoteDetails.broker_admin_fee = response.result.quote_data.quote_versions[0].financial_details.broker_admin_fee;
          } else {
            this.quoteDetails.peliwica_fee = 0;
            this.quoteDetails.broker_commission = 0;
            this.quoteDetails.broker_admin_fee = 0;
          }
          this.quoteDetails.email = response.result.quote_data.quote_versions[0].policy_holder?.email;
          this.quoteDetails.phone = response.result.quote_data.quote_versions[0].policy_holder?.phone;
          this.quoteDetails.is_email = response.result.quote_data.quote_versions[0].policy_holder?.is_email;
          this.quoteDetails.is_phone = response.result.quote_data.quote_versions[0].policy_holder?.is_phone;
          this.quoteDetails.sms = response.result.quote_data.quote_versions[0].policy_holder?.sms;
          this.quoteDetails.post = response.result.quote_data.quote_versions[0].policy_holder?.post;
          this.quoteDetails.transactional_date = response.result.quote_data.quote_versions[0].transactional_date;
          this.fullQuote = response.result.quote_data.quote_versions[0];
          this.quoteDetails.is_paid = response.result.quote_data.quote_versions[0].is_paid;
          this.quoteDetails.product_id = response.result.quote_data.quote_versions[0].product_id;
          this.quoteDetails.is_policy = response.result.quote_data.quote_versions[0].is_policy;
          const appVehicles = this.quoteDetails.application?.vehicles;
          if (appVehicles && appVehicles.length > 0) {
            this.quoteDetails.cars = appVehicles.filter((v: any) => v.type === 'cars');
            this.quoteDetails.commercial_vehicles = appVehicles.filter((v: any) => v.type === 'commercial');
            this.quoteDetails.agricultural_vehicles = appVehicles.filter((v: any) => v.type === 'agricultural');
            this.quoteDetails.horseboxes = appVehicles.filter((v: any) => v.type === 'horsebox' || v.type === 'horseboxes');
            this.quoteDetails.trailers = appVehicles.filter((v: any) => v.type === 'trailer' || v.type === 'trailers');
          }
          this.getQuoteNotes();
        },
        (error) => { }
      );
  }

  issueQuotePopup(issueQuoteModal) { this.modalService.open(issueQuoteModal, { centered: true }); }
  issueQuote() {
    let data = { "agriculture_quote_id": this.route.snapshot.params.quote_id };
    this.as.issueQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.modalService.dismissAll();
            this.router.navigateByUrl("/agrimotor/policy/" + this.id);
          }
        });
  }

  markAsReferred(referQuoteModal) { this.modalService.open(referQuoteModal, { centered: true }); }

  refer_reason: string = '';
  refer_reason_error: boolean = false;
  onReferReasonChange(value: string): void {
    this.refer_reason_error = false;
    if (this.refer_reason == '') { this.refer_reason_error = true; }
  }

  referQuote() {
    this.refer_reason_error = false;
    if (this.refer_reason == '') { this.refer_reason_error = true; return; }
    let data = {
      data: {
        "type": this.fullQuote.agriculture_data.data.type,
        "attributes": this.fullQuote.agriculture_data.data.attributes,
        "id": this.fullQuote.agriculture_data.data.id,
        "broker_id": this.fullQuote.broker_id,
        "company_id": this.fullQuote.company_id,
        "sequence_number": this.fullQuote.sequence_number,
        "quote_meta_id": this.fullQuote.quote_meta_id,
      },
      meta: { "refer": true, "refer_reason": this.refer_reason },
    };
    this.as.saveQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.getQuote();
            this._snackBar.open(res.message, '', { duration: 5000, panelClass: 'text-success' });
          } else {
            this._snackBar.open(res.message, '', { duration: 5000, panelClass: 'text-danger' });
          }
          this.modalService.dismissAll();
        });
  }

  hasImportantNotes: boolean = false;
  totalImpNotes: number = 0;
  getQuoteNotes() {
    this.quoteService.getNotes(this.quoteDetails.id)
      .subscribe(
        (response: any) => {
          let impNotes = response.result.filter(x => x.is_important == 1);
          this.totalImpNotes = impNotes.length;
          if (impNotes.length > 0) { this.hasImportantNotes = true; }
        });
  }

  onhasImportantNotesChange(event) {
    this.hasImportantNotes = event;
    this.totalImpNotes = this.totalImpNotes + 1;
  }

  displayEmailView: boolean = false;
  displayNewEmailView: boolean = false;
  newEmailView() { this.displayNewEmailView = true; }
  email_id: string = '';
  getEmailView(email_id) { this.email_id = email_id; this.displayEmailView = true; }
  backToEmailsList() { this.displayEmailView = false; this.displayNewEmailView = false; }
}
